<template>
  <div>
    <!--dialog for mobile-->
    <v-dialog
      v-model="dialog"
      v-if="isMobile"
      scrollable
      full-width
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-toolbar color="primary" dark fixed>
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="ma-0">View Submission</v-toolbar-title>
        <v-spacer></v-spacer>
        <action-icons
          :marginZero="true"
          :fromDashboard="fromDashboard"
          :submission="submission"
          v-on:service-log:deleted="slDeleted"
        ></action-icons>
      </v-toolbar>
      <v-card>
        <v-card-text style="padding-top: 70px;">
          <confirmation-page
            :fromDashboard="fromDashboard"
            :submission="submission"
            v-on:close:dialog="slDeleted"
            :dialog="dialog">
          </confirmation-page>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--dialog for non mobile-->
    <v-dialog
      max-width="900px"
      v-model="dialog" v-if="!isMobile">
      <v-toolbar color="primary" dark>
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="ma-0">View Submission</v-toolbar-title>
        <v-spacer></v-spacer>
        <action-icons
          :fromDashboard="fromDashboard"
          :submission="submission"
          v-on:service-log:deleted="slDeleted"
        ></action-icons>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <confirmation-page
            :submission="submission"
            :dialog="dialog">
          </confirmation-page>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmationPage from '@/views/service-log/confirmation-page';
import ActionIcons from '@/components/action-icons';

export default {
  name: 'SubmissionHistory',
  props: ['submission', 'fromDashboard'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  components: {
    ConfirmationPage,
    ActionIcons
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    slDeleted() {
      this.dialog = false;
      this.$emit('reload:page');
    }
  },
  mounted() {
    this.dialog = true;
  },
  watch: {
    dialog() {
      if (!this.dialog) this.$emit('dialog:closed');
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/service-log/history/submission-history-dialog.vue